export const ORDERS_LIST_TYPE = {
  PENDING: 'pending',
  COMPLETED: 'completed',
  FAILED_PAYMENTS: 'payment_failed',
};

export const TABS_DATA = [
  {
    text: 'Pending',
    key: ORDERS_LIST_TYPE.PENDING,
  },
  {
    text: 'Completed',
    key: ORDERS_LIST_TYPE.COMPLETED,
  },
  {
    text: 'Failed',
    key: ORDERS_LIST_TYPE.FAILED_PAYMENTS,
  },
];

export const TABS_DATA_MAP = TABS_DATA.reduce((result, tabsData) => {
  result[tabsData.key] = tabsData;
  return result;
}, {});
